import { AnnouncementLabel } from '@/components/Layout/Header/Header.styles';
import {
  ImageWrapper,
  PanelHeader,
  PanelWrapper,
  ValueDescription,
  ValueIcon,
  ValueItem,
  ValueItemList,
  ValueTitle,
} from '@/components/OnboardingPopup/LeftPanel/LeftPanel.styles';
import styled from 'styled-components';

export const TrackingLeftPanelWrapper = styled(PanelWrapper)`
  display: none;
  background-color: ${({ theme }) => theme.colors.darkBlue};
  background-image: url('/images/intro_panel_graphic.svg');
  background-position: bottom -52px left -70px;
  background-repeat: no-repeat;
  background-size: 140%;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    display: flex;
  }
`;

export const PMTLogo = styled.img.attrs({
  src: '/images/icons/monitor_logo.svg',
})`
  display: none;

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    display: block;
    width: 200px;
    margin-bottom: ${({ theme }) => theme.spacing[24]};
  }
`;

export const TrackingPanelHeader = styled(PanelHeader)``;

export const TrackingValueItem = styled(ValueItem)``;

export const TrackingValueItemList = styled(ValueItemList)``;

export const TrackingValueIcon = styled(ValueIcon)``;

export const TrackingValueTitle = styled(ValueTitle)({
  wordBreak: 'break-all',
});

export const TrackingValueDescription = styled(ValueDescription)``;

export const TrackingImageWrapper = styled(ImageWrapper)``;

export const TrackingValueAnnouncementLabel = styled(AnnouncementLabel)(({ theme }) => ({
  border: `solid 1px ${theme.colors.highEmphasisWhite}`,
  marginLeft: theme.spacing[8],
}));
